import React from 'react'
import PropTypes from 'prop-types'
import { Stack, Box, Typography, Icon } from '@mui/material'
import { map, template } from 'lodash'
import FtpItemMenu from './FtpItemMenu'
import { getIconFromFileType, formatDate, formatSize, isFolder } from './FtpUtils'
import { NewTable, WrapperBox } from 'components/datatable/NewTable'
import i18n from 'simple-react-i18n'
import { Search } from '@mui/icons-material'

const FtpSearchResults = ({ searchResults, searchQuery, onNavigate, onReload }) => {
    const headers = [
        { key: 'nullValueIcon', value: '', width: 44 },
        { key: 'name', value: i18n.name },
        { key: 'path', value: i18n.path },
        { key: 'modifiedAt', value: i18n.ftpModifiedAt },
        { key: 'size', value: i18n.size },
        { key: 'nullValueActions', value: '', width: 48 },
    ]
    if (!searchResults || searchResults.length === 0) {
        return (
            <Stack alignItems='center' py={8}>
                <Search sx={{ fontSize: '4rem', mb: 2, color: 'divider' }} />
                <Typography variant='body1' sx={{ fontWeight: 500, color: 'text.primary' }}>
                    {i18n.noResults}
                </Typography>
                <Typography variant='body2' mt={0.5}>
                    {i18n.ftpTryAnotherKeyword}
                </Typography>
            </Stack>
        )
    }

    const trimmedQuery = searchQuery.trim()

    const rows = map(searchResults, (item) => {
        const iconName = getIconFromFileType(item.fileType)
        const isFolderNode = isFolder(item)
        return {
            nullValueIcon: (
                <Icon sx={{ fontSize: '1.25rem', color: 'text.secondary', display: 'block' }}>
                    {iconName}
                </Icon>
            ),
            name: {
                value: isFolderNode ? (
                    <Typography
                        variant='body2'
                        sx={{ fontWeight: 500, color: 'text.primary', fontSize: '0.875rem', cursor: 'pointer' }}
                        onClick={() => onNavigate(item)}
                    >
                        {item.label}
                    </Typography>
                ) : item.label,
                sortValue: item.label,
            },
            path: {
                value: (
                    <Typography variant='body2' sx={{ color: 'text.secondary', fontSize: '0.75rem', fontFamily: 'monospace' }}>
                        {item.path}
                    </Typography>
                ),
                sortValue: item.path,
            },
            modifiedAt: { value: formatDate(item.modifiedAt), sortValue: item.modifiedAt || '' },
            size: { value: isFolderNode ? '—' : formatSize(item.size), sortValue: item.size || 0 },
            nullValueActions: <FtpItemMenu item={item} onReload={onReload} />,
        }
    })

    return (
        <Box>
            <Typography
                variant='body2'
                sx={{ fontWeight: 600, color: 'text.primary', mb: 1.5, fontSize: '0.85rem' }}
            >
                {template(searchResults.length === 1 ? i18n.ftpSearchResultSingle : i18n.ftpSearchResultPlural)({
                    count: searchResults.length,
                    query: trimmedQuery,
                })}
            </Typography>
            <NewTable
                rows={rows}
                headers={headers}
                WrapperComponent={WrapperBox}
            />
        </Box>
    )
}

FtpSearchResults.propTypes = {
    searchResults: PropTypes.array.isRequired,
    searchQuery: PropTypes.string.isRequired,
    onNavigate: PropTypes.func.isRequired,
    onReload: PropTypes.func.isRequired,
}

export default FtpSearchResults
